import React from "react";
import {
  Paper,
  Box,
  Typography,
  Divider,
  List,
  ListItemIcon,
} from "@mui/material";

import { useSelector } from "react-redux";

// الأيقونات
import RuleRoundedIcon from '@mui/icons-material/RuleRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import Loader from "../utils/Loader";
import { HList, VList } from "../utils/layouts";

export default function CriteriaBar() {
  // جلب المعايير (المحاور) وحالة التحميل من Redux مباشرة
  const { criteria, loading } = useSelector((state) => state.session) || {};

  return (
    <Paper
      elevation={0}
      variant="section"
    >
      {/* ترويسة البطاقة */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <RuleRoundedIcon color="secondary" />
        <Typography variant="sectionTitle" >
          محاور التقييم (المعايير)
        </Typography>
      </Box>

      <Divider sx={{ mb: 2}} />

      {/* منطقة عرض المحاور */}
      <Box sx={{ width: "100%" }}>
        {loading ? (
          <Loader text="جاري تحميل المحاور ..."/>
        ) : criteria && criteria.length > 0 ? (
          <Paper variant="glass">
  <List disablePadding>
    {criteria.map((item, index) => (
      <React.Fragment key={index}>
        <Box sx={{ display: 'flex', my: '5px', alignItems: 'center' }}>
          <ListItemIcon sx={{ minWidth: 36 }}>
            <CheckCircleRoundedIcon color="success" fontSize="small" />
          </ListItemIcon>
          <Typography variant="text">{item.title}</Typography> 
        </Box>
        
        {/* الشرط السحري: ارسم الخط فقط إذا لم يكن هذا هو العنصر الأخير */}
        {index !== criteria.length - 1 && <Divider />}
      </React.Fragment>
    ))}
  </List>
</Paper>
        ) : (
          <Typography variant="error-hint-card">
            لا توجد محاور تقييم مخصصة لهذا الدرس.
          </Typography>
        )}
      </Box>
    </Paper>
  );
}